import React, { memo } from 'react';
import { oneOf, shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { click } from './events';
import './full-card.scss';

const FullCard = ({ channel, type, header, details }) => {

  const { title, description: headerDescription } = header;
  const { description, imageUrl, link } = details;
  const specialSymbol = 'â€™';
  const detailsDescription = description?.replace(specialSymbol, '\'');

  const renderFullCardDesktop = () => (
    <section className="full-card__zone col__12-12">
      <div className="full-card__header-wrapper">
        <div className="full-card__header-block">
          <h2 className="full-card__header u__bold">{title}</h2>
          <p className="full-card__header-text full-card__header-text__truncate">
            {type === 'rental'
              ? `Rent a ${headerDescription}`
              : `${headerDescription}`}
          </p>
        </div>
        {type === 'rental' && (
          <div className="full-card-details__logo">Tool Rental</div>
        )}
        {type === 'install' && (
          <div className="full-card-details__serviceslogo" />
        )}
      </div>
      <div className="full-card-details">
        <div className="full-card-details__image">
          <Image src={imageUrl} alt="" stretchy />
        </div>
        <div className="full-card-details__description">
          {type === 'rental'
            ? (
              <div className="full-card-details__text">
                Prefer to Rent?
                <br />
                Your store may have the right solution!
              </div>
            )
            : <div className="full-card-details__text full-card-details__text--truncate">{detailsDescription}</div>}
          <div className="full-card-details__actions">
            <a
              className="bttn-outline bttn-outline--primary bttn--inline full-card-details__btn"
              href={link}
              onClick={() => {
                click({
                  pageNumber: 1,
                  position: 'r1',
                  type: title
                });
              }}
            >
              {type === 'rental' && (
                <span className="bttn__content">View Rentals</span>
              )}
              {type === 'install' && (
                <span className="bttn__content">Learn More</span>
              )}
              {type === 'guide' && (
                <span className="bttn__content">Read Our Guide</span>
              )}
            </a>
          </div>
        </div>
      </div>
    </section>
  );

  const renderFullCardMobile = () => (
    <a className="carousel-card full-carousel-card" href={link}>
      <div className="carousel-card__header-wrapper">
        <div className="carousel-card__header u__bold">{title}</div>
        <div className="carousel-card__header-text">{headerDescription}</div>
        <div className="carousel-card__title-border" />
        <div className="carousel-card__description">
          <div className="carousel-card__text carousel-card__text--truncate">
            {detailsDescription}
          </div>
        </div>
      </div>
      <div className="carousel-card__image-wrapper">
        <div className="carousel-card__image">
          <Image src={imageUrl} alt="" />
        </div>
      </div>
    </a>
  );

  return channel === 'desktop'
    ? renderFullCardDesktop()
    : renderFullCardMobile();
};

FullCard.displayName = 'CategoryCards-FullCard';

FullCard.propTypes = {
  channel: oneOf(['desktop', 'mobile']),
  header: shape({
    title: string,
    description: string
  }).isRequired,
  details: shape({
    imageUrl: string,
    description: string,
    link: string
  }).isRequired,
  type: string.isRequired
};

FullCard.defaultProps = {
  channel: 'desktop'
};

const MemoFullCard = memo(FullCard);

export { MemoFullCard as FullCard };
